import * as Yup from "yup";
import { ERROR_MSG } from "../../constants/messages";

export const underskrivValidationSchema = Yup.object({
  email: Yup.string()
    .email(ERROR_MSG.email)
    .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/, ERROR_MSG.email)
    .required(ERROR_MSG.required),
  email2: Yup.string()
    .nullable()
    .email(ERROR_MSG.email)
    .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/, ERROR_MSG.email),
});
